import { render, staticRenderFns } from "./UserLinks.vue?vue&type=template&id=4b199585"
import script from "./UserLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLinks.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports